import { Line } from 'vue-chartjs'
import { currency } from '@/helpers/currency'

export default {
  extends: Line,
  props: {
    chartData: {
      type: Array | Object,
      required: false
    },
    chartLabels: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      gradient: null,
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              drawBorder: false,
              borderDash: [3, 3],
              color: '#c8ced3'
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false,
        bezierCurve: false,
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        },
        tooltips: {
          titleFontSize: 14,
          bodyFontSize: 16,
          xPadding: 20,
          yPadding: 20,
          custom: (tooltip) => {
            if (!tooltip) return
            tooltip.displayColors = false
          },
          callbacks: {
            title: (tooltipItem, data) => {
              return tooltipItem[0].xLabel
            },
            label: (items, data) => {
              return 'Total: ' + currency(data.datasets[0].data[items.index])
            }
          }
        },
        onClick: this.chartClickEvent
      }
    }
  },
  mounted () {
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 550)
    this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 550)

    this.gradient.addColorStop(0, 'rgba(77, 189, 116, 0.5)')
    this.gradient.addColorStop(0.5, 'rgba(77, 189, 116, 0.25)')
    this.gradient.addColorStop(1, 'rgba(77, 189, 116, 0)')

    this.renderChart({
      labels: this.chartLabels,
      datasets: [
        {
          label: 'Number of Transaction',
          borderColor: '#82ca9d',
          pointBackgroundColor: 'transparent',
          borderWidth: 4,
          pointBorderColor: '#82ca9d',
          pointHoverBorderColor: 'white',
          pointHoverBackgroundColor: '#82ca9d',
          pointHoverRadius: 10,
          pointRadius: 4,
          backgroundColor: this.gradient,
          data: this.chartData
        }
      ]
    }, this.options)
  },
  methods: {
    currency: currency
  }
}
